var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinLogoCircle = function SvgLinkedinLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.2 744.8h91.9V377.3h-91.9v367.5zm367.5-367.5c-78.7 1.3-117.4 58.6-122.5 61.3v-61.3h-91.9v367.5h91.9V530.4a78 78 0 0191.9-61.2c38.9 2.5 59.9 54 61.3 61.2v214.4l91.5.4V490.8c-3.3-36.7-21.7-112.2-122.2-113.5zM301.1 254.8a45.8 45.8 0 10-.1 91.7 45.8 45.8 0 00.1-91.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 475,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 50
  })));
};
export default SvgLinkedinLogoCircle;